(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pd-size-guide"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-pd-size-guide-open]').forEach((opener) => {
    opener.addEventListener('click', () => {
      document.getElementById(opener.dataset.pdSizeGuideOpen)?.showModal();
    });
  });

  document.querySelectorAll('.pd-size-guide').forEach((dialog) => {
    dialog.querySelector('[data-pd-size-guide-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
